function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import EndorsementTypes from "./EndorsementTypes";
import UserForm from "./UserForm";
import { getDifferenceInDays } from "../../../utils/datetime";
import { getSeparatorByCurrency, roundTo } from "../../../utils/currency";
import { CurrencyTypes } from "../../../utils/data";
import { aseguradoAmountFormula } from "./EndorsementTypes/AmountFormFormulas";

var SelectedTypeForm = function SelectedTypeForm(props) {
  var poliza = props.poliza,
      polizaEndorsement = props.polizaEndorsement,
      polizaEndorsementForm = props.polizaEndorsementForm,
      setPolizaEndorsementForm = props.setPolizaEndorsementForm,
      cancel_reasons = props.cancel_reasons,
      regions = props.regions,
      communes = props.communes,
      _props$editMode = props.editMode,
      editMode = _props$editMode === void 0 ? false : _props$editMode;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      manualOverride = _React$useState2[0],
      setManualOverride = _React$useState2[1];

  var decimalFormat = getSeparatorByCurrency(CurrencyTypes.PERCENTAGE);
  var currencyFormat = getSeparatorByCurrency(poliza.currency);

  var onChangeDuration = function onChangeDuration(newItem) {
    var _new_data$poliza_para, _new_data$poliza_para2, _poliza$broker_inform, _poliza$broker_inform2, _poliza$broker_inform3, _poliza$broker_inform4, _new_data$differences, _new_data$differences2;

    var new_data = _objectSpread(_objectSpread({}, polizaEndorsementForm), {}, {
      poliza_params: _objectSpread(_objectSpread({}, polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : polizaEndorsementForm.poliza_params), newItem)
    });

    var new_start_date = ((_new_data$poliza_para = new_data.poliza_params) === null || _new_data$poliza_para === void 0 ? void 0 : _new_data$poliza_para.start_date) || poliza.start_date;
    var new_finish_date = ((_new_data$poliza_para2 = new_data.poliza_params) === null || _new_data$poliza_para2 === void 0 ? void 0 : _new_data$poliza_para2.finish_date) || poliza.finish_date;
    var old_duration = getDifferenceInDays(poliza.start_date, poliza.finish_date);
    var new_duration = getDifferenceInDays(new_start_date, new_finish_date);
    var percent_diff = new_duration / old_duration;
    var new_exempt_net_bonus = roundTo(((_poliza$broker_inform = poliza.broker_information) === null || _poliza$broker_inform === void 0 ? void 0 : _poliza$broker_inform.exempt_net_bonus) * percent_diff, 2);
    var new_affects_net_bonus = roundTo(((_poliza$broker_inform2 = poliza.broker_information) === null || _poliza$broker_inform2 === void 0 ? void 0 : _poliza$broker_inform2.affects_net_bonus) * percent_diff, 2);
    var endorsement_exempt_net_bonus = roundTo(new_exempt_net_bonus - ((_poliza$broker_inform3 = poliza.broker_information) === null || _poliza$broker_inform3 === void 0 ? void 0 : _poliza$broker_inform3.exempt_net_bonus), 2);
    var endorsement_affects_net_bonus = roundTo(new_affects_net_bonus - ((_poliza$broker_inform4 = poliza.broker_information) === null || _poliza$broker_inform4 === void 0 ? void 0 : _poliza$broker_inform4.affects_net_bonus), 2);

    var duration_information = _objectSpread(_objectSpread({}, new_data), {}, {
      poliza_params: _objectSpread(_objectSpread({}, new_data === null || new_data === void 0 ? void 0 : new_data.poliza_params), {}, {
        start_date: new_start_date,
        finish_date: new_finish_date
      }),
      differences: _objectSpread(_objectSpread({}, new_data === null || new_data === void 0 ? void 0 : new_data.differences), {}, {
        poliza: _objectSpread(_objectSpread({}, new_data === null || new_data === void 0 ? void 0 : (_new_data$differences = new_data.differences) === null || _new_data$differences === void 0 ? void 0 : _new_data$differences.poliza), {}, {
          start_date: new_start_date,
          finish_date: new_finish_date
        }),
        extension: _objectSpread(_objectSpread({}, new_data === null || new_data === void 0 ? void 0 : (_new_data$differences2 = new_data.differences) === null || _new_data$differences2 === void 0 ? void 0 : _new_data$differences2.extension), {}, {
          old_duration: old_duration,
          new_duration: new_duration,
          difference: new_duration - old_duration
        })
      })
    });

    if (manualOverride) {
      onChangeAmount(_objectSpread(_objectSpread({}, polizaEndorsementForm), duration_information));
    } else {
      onChangeAmount(_objectSpread(_objectSpread(_objectSpread({}, polizaEndorsementForm), duration_information), {}, {
        exempt_net_bonus: endorsement_exempt_net_bonus,
        affects_net_bonus: endorsement_affects_net_bonus
      }));
    }
  };

  var onChangeAmount = function onChangeAmount(newItem) {
    var _new_data$poliza_para3, _poliza$broker_inform5, _poliza$broker_inform6, _poliza$broker_inform7, _poliza$broker_inform8, _poliza$broker_inform9;

    var new_data = _objectSpread(_objectSpread({}, polizaEndorsementForm), newItem);

    var net_bonus = roundTo(new_data.affects_net_bonus + new_data.exempt_net_bonus, currencyFormat.decimalLimit);
    var iva = roundTo(new_data.affects_net_bonus * 0.19, currencyFormat.decimalLimit);
    var total_bonus = new_data.affects_net_bonus + new_data.exempt_net_bonus + iva;
    var broker_commission = new_data.affects_net_bonus * (new_data.commission_affect / 100) + new_data.exempt_net_bonus * (new_data.commission_exempt / 100);
    var agent_commission = (new_data.affects_net_bonus * (new_data.commission_affect / 100) + new_data.exempt_net_bonus * (new_data.commission_exempt / 100)) * (new_data.commission_percentage / 100);

    var amount_information = _objectSpread(_objectSpread({}, new_data), {}, {
      net_bonus: roundTo(net_bonus, currencyFormat.decimalLimit),
      iva: roundTo(iva, currencyFormat.decimalLimit),
      total_bonus: roundTo(total_bonus, currencyFormat.decimalLimit),
      broker_commission: roundTo(broker_commission, currencyFormat.decimalLimit),
      agent_commission: roundTo(agent_commission, currencyFormat.decimalLimit),
      poliza_params: _objectSpread(_objectSpread({}, new_data.poliza_params), {}, {
        commission: _objectSpread(_objectSpread({}, (_new_data$poliza_para3 = new_data.poliza_params) === null || _new_data$poliza_para3 === void 0 ? void 0 : _new_data$poliza_para3.commission), {}, {
          exempt_net_bonus: roundTo(new_data.exempt_net_bonus + ((poliza === null || poliza === void 0 ? void 0 : (_poliza$broker_inform5 = poliza.broker_information) === null || _poliza$broker_inform5 === void 0 ? void 0 : _poliza$broker_inform5.exempt_net_bonus) || 0), currencyFormat.decimalLimit),
          affects_net_bonus: roundTo(new_data.affects_net_bonus + ((poliza === null || poliza === void 0 ? void 0 : (_poliza$broker_inform6 = poliza.broker_information) === null || _poliza$broker_inform6 === void 0 ? void 0 : _poliza$broker_inform6.affects_net_bonus) || 0), currencyFormat.decimalLimit),
          net_bonus: roundTo(net_bonus + ((poliza === null || poliza === void 0 ? void 0 : (_poliza$broker_inform7 = poliza.broker_information) === null || _poliza$broker_inform7 === void 0 ? void 0 : _poliza$broker_inform7.net_bonus) || 0), currencyFormat.decimalLimit),
          iva: roundTo(iva + ((poliza === null || poliza === void 0 ? void 0 : (_poliza$broker_inform8 = poliza.broker_information) === null || _poliza$broker_inform8 === void 0 ? void 0 : _poliza$broker_inform8.iva) || 0), currencyFormat.decimalLimit),
          total_bonus: roundTo(total_bonus + ((poliza === null || poliza === void 0 ? void 0 : (_poliza$broker_inform9 = poliza.broker_information) === null || _poliza$broker_inform9 === void 0 ? void 0 : _poliza$broker_inform9.total_bonus) || 0), decimalFormat.decimalLimit)
        })
      })
    });

    setPolizaEndorsementForm(_objectSpread(_objectSpread({}, polizaEndorsementForm), amount_information));
  };

  var onChangeAmountDifference = function onChangeAmountDifference(newItem) {
    var _polizaEndorsementFor, _polizaEndorsementFor2;

    var amountChangeDifference = (newItem === null || newItem === void 0 ? void 0 : newItem.amount_change_difference) || (polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : (_polizaEndorsementFor = polizaEndorsementForm.poliza_params) === null || _polizaEndorsementFor === void 0 ? void 0 : _polizaEndorsementFor.amount_change_difference) || null;
    var amountChangeDate = (newItem === null || newItem === void 0 ? void 0 : newItem.amount_change_date) || (polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : (_polizaEndorsementFor2 = polizaEndorsementForm.poliza_params) === null || _polizaEndorsementFor2 === void 0 ? void 0 : _polizaEndorsementFor2.amount_change_date); // Empty case

    if (!amountChangeDifference || !amountChangeDate) {
      setPolizaEndorsementForm(_objectSpread(_objectSpread({}, polizaEndorsementForm), {}, {
        poliza_params: {
          new_asegurado_amount: poliza.total_asegurado_amount + amountChangeDifference,
          amount_change_difference: amountChangeDifference,
          amount_change_date: amountChangeDate
        }
      }));
      return;
    } // When both values exist, proceed to calculate the new affectNetBonus and exemptNetBonus


    var _aseguradoAmountFormu = aseguradoAmountFormula(poliza, amountChangeDate, amountChangeDifference),
        newAffectNetBonus = _aseguradoAmountFormu.newAffectNetBonus,
        newExemptNetBonus = _aseguradoAmountFormu.newExemptNetBonus; // Setting the new changes


    onChangeAmount({
      affects_net_bonus: roundTo(newAffectNetBonus, 4),
      exempt_net_bonus: roundTo(newExemptNetBonus, 4),
      poliza_params: {
        new_asegurado_amount: poliza.total_asegurado_amount + amountChangeDifference,
        amount_change_difference: amountChangeDifference,
        amount_change_date: amountChangeDate
      }
    });
  };

  switch (polizaEndorsementForm.endorsement_type) {
    case "increase_amount":
      return /*#__PURE__*/React.createElement(EndorsementTypes.IncreaseAmountForm, {
        canModify: true,
        poliza: poliza,
        polizaEndorsementForm: polizaEndorsementForm,
        onChangeAmount: onChangeAmount,
        onChangeAmountDifference: onChangeAmountDifference
      });

    case "decrease_amount":
      return /*#__PURE__*/React.createElement(EndorsementTypes.DecreaseAmountForm, {
        canModify: true,
        forceNegative: true,
        poliza: poliza,
        polizaEndorsementForm: polizaEndorsementForm,
        onChangeAmount: onChangeAmount,
        onChangeAmountDifference: onChangeAmountDifference
      });

    case "extension":
      return /*#__PURE__*/React.createElement(EndorsementTypes.ExtensionForm, {
        poliza: poliza,
        polizaEndorsementForm: polizaEndorsementForm,
        onChangeDuration: onChangeDuration,
        onChangeAmount: onChangeAmount
      });

    case "cancellation":
      return /*#__PURE__*/React.createElement(EndorsementTypes.CancellationForm, {
        poliza: poliza,
        polizaEndorsement: polizaEndorsement,
        polizaEndorsementForm: polizaEndorsementForm,
        onChangeDuration: onChangeDuration,
        onChangeAmount: onChangeAmount,
        cancelReasons: cancel_reasons,
        setPolizaEndorsementForm: setPolizaEndorsementForm
      });

    case "annulment":
      return /*#__PURE__*/React.createElement(EndorsementTypes.AnnulmentForm, {
        poliza: poliza,
        polizaEndorsement: polizaEndorsement,
        polizaEndorsementForm: polizaEndorsementForm,
        onChangeAmount: onChangeAmount,
        cancelReasons: cancel_reasons
      });

    case "reenable":
      return /*#__PURE__*/React.createElement(EndorsementTypes.ReenableForm, {
        canModify: true,
        poliza: poliza,
        polizaEndorsement: polizaEndorsement,
        polizaEndorsementForm: polizaEndorsementForm,
        onChangeAmount: onChangeAmount,
        editMode: editMode
      });

    case "minute":
      return /*#__PURE__*/React.createElement(EndorsementTypes.Minute, {
        canModify: true,
        isDefaultOverrideActive: true,
        poliza: poliza,
        polizaEndorsementForm: polizaEndorsementForm,
        onChangeAmount: onChangeAmount
      });

    case "change_beneficiary":
      return /*#__PURE__*/React.createElement(UserForm, {
        currentType: "beneficiario",
        poliza: poliza,
        polizaEndorsementForm: polizaEndorsementForm,
        setPolizaEndorsementForm: setPolizaEndorsementForm,
        regions: regions,
        communes: communes
      });

    case "change_contractor":
      return /*#__PURE__*/React.createElement(UserForm, {
        currentType: "contratante",
        poliza: poliza,
        polizaEndorsementForm: polizaEndorsementForm,
        setPolizaEndorsementForm: setPolizaEndorsementForm,
        regions: regions,
        communes: communes
      });

    case "change_person_information":
      return /*#__PURE__*/React.createElement(UserForm, {
        currentType: "asegurado",
        poliza: poliza,
        polizaEndorsementForm: polizaEndorsementForm,
        setPolizaEndorsementForm: setPolizaEndorsementForm,
        regions: regions,
        communes: communes
      });

    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};

export default SelectedTypeForm;